import React from "react"
import Ajax from 'superagent'
import PropTypes from "prop-types"
import { Panel } from "react-bootstrap"
import { Link } from "react-router"
import moment from "moment"
import { connect } from "react-redux"
import { compact } from "lodash"

import Button from "../components/Button"
import MultiLineChart from "./MultiLineChart"

import "./PartnerPayments.less"

const Timestamp = ({ ts }) => (
  <HoverTip text={ts}><span><Glyphicon glyph="time" /> {moment(ts).format("LL")}</span></HoverTip>
)

// #TODO renombrar; ya no es sólo pagos

const d = ts => moment(ts).format("YYYY-MM-DD HH:mm")

class PartnerPayments extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      data: null
    }
  }
  
  update() {
    Ajax.get(`/adPartner/${this.props.partnerId}`)
      .then(res => this.setState({ data: res.body }))
      .catch(err => console.log(err))
  }
  
  componentDidMount() {
    setTimeout(() => this.update(), 300)
  }
  
  componentDidUpdate(prevProps, _prevState) {
    if (prevProps.partnerId != this.props.partnerId) {
      this.update()
    }
  }
  
  addPayment() {
    const s = prompt("¿Cuánto?")
    const ammount = parseInt(s)
    if (ammount === 0) { alert("No voy a añadir 0 euros...") }
    else if (!ammount) { alert("No entiendo ese número.") }
    else {
      Ajax.post(`/adPartnerPayment/${this.props.partnerId}`)
        .send({ ammount })
        .then(res => {
          if (res.status == 200) {
            setTimeout(() => this.update(), 150)
          }
          else {
            alert(`Something went wrong: ${res.status}`)
            console.error(res)
          }
        })
        .catch(err => {
          alert(`Something went wrong: ${JSON.stringify(err)}`)
          console.error(err)
        })
    }
  }
  
  deletePayment(paymentKey) {
    const payment = this.state.data.partner.payments.find(p => p.key == paymentKey)
    if (confirm(`¿Eliminar el pago de ${payment.ammount} registrado en ${d(payment.timestamp)}`)) {
      Ajax.delete(`/adPartnerPayment/${this.props.partnerId}/${paymentKey}`)
        .then(res => {
          if (res.status == 200) {
            setTimeout(() => this.update(), 150)
          }
          else {
            alert(`Something went wrong: ${res.status}`)
            console.error(res)
          }
        })
        .catch(err => {
          alert(`Something went wrong: ${JSON.stringify(err)}`)
          console.error(err)
        })
    }
  }
  
  render() {
    if (!this.state.data || !this.props.activities || !this.props.trips) {
      return "Loading..."
    } 

    const { 
      partner, viewsPerMonth, totalViews, firstViewDocs,
      expended, totalPaid, remaining, docsPerMonth
    } = this.state.data    
    
    const activityId = this.state.data.partner.publiActivity
    const activity = this.props.activities[activityId]
    
    return (
      <div className="PartnerPayments">
        <div className="activity">
          Actividad de publicidad: <Link to={`/private/activity/${activity._id}`}>{activity.name || "[NO NAME]"}</Link>
        </div>
          
        <div className="flex">
          <Panel>
            <Panel.Heading>
              <Panel.Title>Clientes impactados ({totalViews})</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <ul>
                {
                  Object.keys(docsPerMonth).map(year => (
                    <li key={year}>
                      <span>{year}</span>
                      <ul>
                        {
                          docsPerMonth[year].map(doc => {
                            const trip = this.props.trips[doc.tripId]
                            const name = compact([trip.name, trip.realName, trip.officialName, trip._id]).slice(0, 2).join(" / ")
                            return (
                              <li key={doc.tripId}><Link to={`/private/trip/${doc.tripId}`}>{name}</Link></li>
                            )
                          })
                        }
                      </ul>
                    </li>
                  ))
                }
              </ul>
            </Panel.Body>
          </Panel>
          
          <Panel>
            <Panel.Heading>
              <Panel.Title>Pagos y saldo</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <ul>
                {
                  (partner.payments || []).map(payment => (
                    <li key={payment.key}>
                      <b>{payment.ammount}€</b> ({moment(payment.timestamp).format("YYYY/MM/DD HH:mm")})
                      <Button bsStyle="xs" onClick={() => this.deletePayment(payment.key)} glyph="minus">
                        Eliminar
                      </Button>
                    </li>
                  ))
                }
                {
                  (!partner.payments || !partner.payments.length) && (
                    <i>Sin pagos</i>
                  )
                }
              </ul>
            </Panel.Body>
            <Panel.Footer>
              <div>Saldo: <b>{remaining}€</b> / {totalPaid}€</div>
              <div>
                <Button glyph="plus" onClick={() => this.addPayment()}>Nuevo pago</Button>
              </div>
            </Panel.Footer>
          </Panel>
        </div>
        
        <p><i>(Sólo se contabiliza cada cliente una vez.)</i></p>
        
        <MultiLineChart firstViewDocs={firstViewDocs} />
        
        {/* <h3>Impresiones incluidas:</h3>
        <ul>
          {
            firstViewDocs.map(doc => {
              const trip = this.props.trips[doc.tripId]
              return (
                <li key={doc._id}>
                  {d(doc.timestamp)}: <Link to={`/private/trip/${trip._id}`}>{trip.name} / {trip.realName}</Link>
                </li>
              )
            })
          }
          { firstViewDocs.length == 0 && <i>Ninguna impresión</i> }
        </ul> */}
        
        {/*         
        <label>State:</label>
        <Json src={this.state} /> */}
      </div>
    )
  }
}

PartnerPayments.propTypes = {
  partnerId: PropTypes.string.isRequired,
}

const mapStateToProps = (state, _props) => ({
  trips: state.trips,
  activities: state.activities,
})

export default connect(mapStateToProps)(PartnerPayments)